import { render, staticRenderFns } from "./event-extra-modules.vue?vue&type=template&id=2244f10b&scoped=true"
import script from "./event-extra-modules.vue?vue&type=script&lang=js"
export * from "./event-extra-modules.vue?vue&type=script&lang=js"
import style0 from "./event-extra-modules.vue?vue&type=style&index=0&id=2244f10b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244f10b",
  null
  
)

export default component.exports